module.exports = __webpack_public_path__ + "img/logo1.2bc5f754.png";